import {
    FileText, Layers, Rocket, Target, Sparkles, FolderKanban, Wrench, HardHat, Zap,
    Leaf, BarChart3, Briefcase, ClipboardList, Trophy, PenTool, Package, Lightbulb,
    Users, Building2, GitBranch, Globe, ShieldCheck, TrendingUp,
} from 'lucide-react';

// Map des noms lucide (kebab-case) vers les composants React.
// Utilisé pour compat backward avec les thèmes historiques (`icon = "file-text"`, "layers"…).
const LUCIDE_MAP = {
    'file-text': FileText,
    'layers': Layers,
    'rocket': Rocket,
    'target': Target,
    'sparkles': Sparkles,
    'folder-kanban': FolderKanban,
    'folder': FolderKanban,
    'wrench': Wrench,
    'hard-hat': HardHat,
    'zap': Zap,
    'leaf': Leaf,
    'bar-chart': BarChart3,
    'bar-chart-3': BarChart3,
    'briefcase': Briefcase,
    'clipboard-list': ClipboardList,
    'trophy': Trophy,
    'pen-tool': PenTool,
    'package': Package,
    'lightbulb': Lightbulb,
    'users': Users,
    'building': Building2,
    'building-2': Building2,
    'git-branch': GitBranch,
    'globe': Globe,
    'shield-check': ShieldCheck,
    'trending-up': TrendingUp,
};

/**
 * Retourne un rendu d'icône pour un thème :
 * - Si `iconField` correspond à un nom lucide connu → renvoie <Icon /> React
 * - Si c'est un emoji ou un texte court → le retourne tel quel
 * - Fallback : icône générique Layers
 */
export function ThemeIcon({ icon, className = 'w-4 h-4', color }) {
    if (!icon) {
        return <Layers className={className} style={color ? { color } : undefined} />;
    }
    const lower = String(icon).toLowerCase().trim();
    const LucideIcon = LUCIDE_MAP[lower];
    if (LucideIcon) {
        return <LucideIcon className={className} style={color ? { color } : undefined} />;
    }
    // Sinon on considère que c'est un emoji ou une string custom → rendu texte
    return <span className={className.replace(/w-\d+|h-\d+/g, '').trim() + ' inline-flex items-center justify-center text-base'}>{icon}</span>;
}

// Options proposées à l'utilisateur dans le picker (mix emoji + lucide)
export const THEME_ICON_OPTIONS = [
    { key: '💡', label: 'Idée', emoji: '💡' },
    { key: '🏗️', label: 'Travaux d’optimisation', emoji: '🏗️' },
    { key: '⚡', label: 'Énergie', emoji: '⚡' },
    { key: '🌱', label: 'Nature', emoji: '🌱' },
    { key: '🚀', label: 'Lancement', emoji: '🚀' },
    { key: '📊', label: 'Data', emoji: '📊' },
    { key: '🎯', label: 'Objectif', emoji: '🎯' },
    { key: '🔧', label: 'Outil', emoji: '🔧' },
    { key: '📝', label: 'Doc', emoji: '📝' },
    { key: '🏆', label: 'Réussite', emoji: '🏆' },
    { key: '💼', label: 'Business', emoji: '💼' },
    { key: '🎨', label: 'Créa', emoji: '🎨' },
];
